import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { capitalize } from 'src/app/static-data/models/consts/static-data.utils';
import { LegalEnum } from '../../model/enums/product-capture.enums';

export function IncrementalTradingValidator(legal: FormGroup) {
  let type: string;

  return {
    buildValidator(fieldType: string): (control: AbstractControl) => ValidationErrors | null {
      type = fieldType;

      const maxTradingField =
        type === LegalEnum.incrementalTradingAmount
          ? LegalEnum.maxTradingAmount
          : LegalEnum.maxTradingUnits;

      return (control: AbstractControl): ValidationErrors | null => validate(control, maxTradingField);
    }
  }

  function validate(
    control: AbstractControl,
    maxTradingField: LegalEnum
  ): ValidationErrors | null {
    const {
      [LegalEnum.denominationLegal]: denominationValue,
      [maxTradingField]: maxTradingAmountLegal,
      [LegalEnum.numberOfUnits]: numberOfUnits
    } = legal.value;

    if (type === 'incrementalTradingAmount' && Number(control.value) % Number(denominationValue)) {
      return { [`invalid${capitalize(type, null, false)}`]: true };
    }

    if (!maxTradingAmountLegal) {
      return null;
    }

    if (Number(control.value) > Number(maxTradingAmountLegal)) {
      return { [`invalid${capitalize(type, null, false)}Maximum`]: true };
    }

    return null;
  }
}
